export const getWheelFeatureId = ({ metadata, wheelInteractionId, wheelInteractionType, streamId }: { metadata: any, wheelInteractionId: any, wheelInteractionType: string, streamId: string }) => {
  const isAllInteractions =
        ['All Interactions', 'allInteractions', ''].includes(wheelInteractionType);

  let metaIdCheck = metadata?.featureId !== undefined && metadata?.featureId !== streamId;
  let wheelIdCheck = wheelInteractionId !== undefined && wheelInteractionId !== streamId;
  let isFeature = false;
  let featureId = '';

  if ((metaIdCheck || wheelIdCheck) && !isAllInteractions) {
    isFeature = true;
    featureId = metadata?.featureId || wheelInteractionId;
  } else {
    isFeature = false;
    featureId = streamId;
  }

  return { isFeature, featureId };
};
